import { Chip } from "@mui/material";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  RecommendationTranslationDto,
  RecommendationDto,
} from "@green0meter/api-client";

import { StyledCard } from "./Item.styled";

import IconBrain from "@icons/Brain";
import { Box, Button, Stack, Typography, Divider } from "@components/base";

interface Component {
  // TODO rename to recommendation
  recommendation: RecommendationDto;
  translation: RecommendationTranslationDto;
}

const Component: FC<Component> = ({ translation, recommendation }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickExplore = (): void => {
    navigate(`/co2/recommendation/${recommendation.external_id}`);
  };

  return (
    <StyledCard>
      <Stack justifyContent="space-between" height="100%" spacing={2}>
        <Stack spacing={2}>
          <Box>
            <Chip
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconBrain sx={{ fontSize: 12 }} />
                  <Typography variant="caption1">
                    {t("recommendationsItem.knowledgeDropInside")}
                  </Typography>
                </Stack>
              }
              variant="filled"
              color="primary"
              size="medium"
            />
          </Box>
          <Typography variant="h6">{translation?.title}</Typography>
          <Typography variant="body2">{translation?.short_description}</Typography>
        </Stack>
        <Stack spacing={2}>
          <Divider />
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontSize={12}>
              {t("recommendationsItem.scope", {
                scope: recommendation.scope.join(", "),
              })}
            </Typography>
            <Button variant="contained" onClick={handleClickExplore}>
              {t("recommendationsItem.explore")}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </StyledCard>
  );
};

export default Component;
